/**
 * Resets a connector's manual start/end anchor back to AUTO (null) — lets
 * AnchorCalculator.edgeToward's dominant-axis edge choice (AnchorCalculator.js)
 * take over instead of whatever anchor point a previous drag/import left
 * behind. Mutates the REAL connector in place — same pattern as
 * UmlCanvasEngine.setConnectorAnchor — no clone, so UmlConnector's own
 * methods (addPoint etc) stay intact.
 * @param {object} connector
 */
export function run(connector) {
    connector.fromAnchorPoint = null;
    connector.toAnchorPoint = null;
}
